$('body').on('click', '.add-project-trigger', function() {
    openModal('.add-project');
    return false;
});

$("body").on("click", ".open-project-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".project-menu-wrapper");

    $(".project-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".project-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".project-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-project-trigger', function() {
    var data = $(this).parents('.project');
    var action = $('.edit-project form').attr('data-action').replace('{project}', data.attr('data-project'));
    $('.edit-project form').attr('action', action);

    $('.edit-project [name="name"]').val(data.attr('data-name'));
    $('.edit-project [name="description"]').val(data.attr('data-description'));
    $('.edit-project [name="google_analytics"]').val(data.attr('data-google_analytics'));
    $('.edit-project [name="google_analytics_beta"]').val(data.attr('data-google_analytics_beta'));
    $('.edit-project [name="mode"][value="'+data.attr('data-mode')+'"]').prop('checked', true);
    $('.edit-project [name="play_mode"][value="'+data.attr('data-play_mode')+'"]').prop('checked', true);
    $('.edit-project [name="slide_play_mode"][value="'+data.attr('data-slide_play_mode')+'"]').prop('checked', true);
    $('.edit-project [name="base_url"]').val(data.attr('data-base_url'));
    $('.edit-project [name="notification_heading"]').val(data.attr('data-notification_heading'));
    $('.edit-project [name="notification_message"]').val(data.attr('data-notification_message'));
    $('.edit-project [name="notification_link"]').val(data.attr('data-notification_link'));
    $('.edit-project [name="sponsor_message"]').val(data.attr('data-sponsor_message'));
    $('.edit-project [name="firebase_url_prefix"]').val(data.attr('data-firebase_url_prefix'));
    $('.edit-project [name="firebase_url_api_key"]').val(data.attr('data-firebase_url_api_key'));
    $('.edit-project [name="save_location"]').prop('checked', data.attr('data-save_location') ? true : false);
    $('.edit-project [name="generate_story_short_url"]').prop('checked', data.attr('data-generate_story_short_url') ? true : false);
    $('.edit-project [name="generate_slide_short_url"]').prop('checked', data.attr('data-generate_slide_short_url') ? true : false);

    openModal('.edit-project');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-project form, .edit-project form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!modal.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-project', function(data) {
    // console.log(data);
    var element;

    if($('.project[data-project="'+data.project+'"]').length) {
        element = $('.project[data-project="'+data.project+'"]');

        element.attr('data-name', data.name);
        element.attr('data-slug', data.slug);
        element.attr('data-description', data.description);
        element.attr('data-google_analytics', data.google_analytics);
        element.attr('data-google_analytics_beta', data.google_analytics_beta);
        element.attr('data-api_key', data.api_key);
        element.attr('data-mode', data.mode);

        element.attr('data-base_url', data.base_url);
        element.attr('data-play_mode', data.play_mode);
        element.attr('data-slide_play_mode', data.slide_play_mode);
        element.attr('data-save_location', data.save_location);
        element.attr('data-notification_heading', data.notification_heading);
        element.attr('data-notification_message', data.notification_message);
        element.attr('data-notification_link', data.notification_link);
        element.attr('data-sponsor_message', data.sponsor_message);
        element.attr('data-generate_story_short_url', data.generate_story_short_url);
        element.attr('data-generate_slide_short_url', data.generate_slide_short_url);
        element.attr('data-firebase_url_prefix', data.firebase_url_prefix);
        element.attr('data-firebase_url_api_key', data.firebase_url_api_key);

        element.find('[data-input="name"]').html(data.name);
        element.find('[data-input="slug"]').html(data.slug);
        element.find('[data-input="mode"]').html(data.mode);
        element.find('[data-input="total_stories"]').html(data.total_stories);
        element.find('[data-input="total_slides"]').html(data.total_slides);
        element.find('.menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'project',
            'data-project': data.project,
            'data-name': data.name,
            'data-slug': data.slug,
            'data-description': data.description,
            'data-google_analytics': data.google_analytics,
            'data-google_analytics_beta': data.google_analytics_beta,
            'data-api_key': data.api_key,
            'data-mode': data.mode,
            'data-base_url': data.base_url,
            'data-play_mode': data.play_mode,
            'data-slide_play_mode': data.slide_play_mode,
            'data-save_location': data.save_location,
            'data-notification_heading': data.notification_heading,
            'data-notification_message': data.notification_message,
            'data-notification_link': data.notification_link,
            'data-generate_story_short_url': data.generate_story_short_url,
            'data-generate_slide_short_url': data.generate_slide_short_url,
            'data-firebase_url_prefix': data.firebase_url_prefix,
            'data-firebase_url_api_key': data.firebase_url_api_key,
            'data-sponsor_message': data.sponsor_message
        });

        element.append(`<td>
            <p data-input="name">${data.name}</p>
            <p class="small-text" data-input="slug">${data.slug}</p>
        </td>
        <td data-input="mode">${data.mode}</td>
        <td data-input="total_stories">${data.total_stories}</td>
        <td data-input="total_slides">${data.total_slides}</td>
        <td data-input="date_added_parsed">${data.date_added_parsed}</td>
        <td class="project-menu-wrapper menu-wrapper" data-dropdown="project-${data.project}">
            <a href="" class="icon-more open-project-menu open-menu"></a>
            <ul class="project-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.projects tbody').prepend(element);
    }
});